import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';
import { useRouter } from 'next/router';

export const useInSessionSchedulingEnabled = (): boolean => {
  const router = useRouter();
  const growthBookEnabled = useFeatureIsOn(
    GROWTHBOOK_FEATURE_FLAGS.IN_SESSION_SCHEDULING,
  );

  const queryParam = router.query['inSessionScheduling'];
  if (queryParam === 'true') {
    return true;
  }
  if (queryParam === 'false') {
    return false;
  }

  return growthBookEnabled;
};
